export const turnNewlinesIntoHTMLBreaks = (text: string | undefined) => {
  if (!text) {
    return <></>;
  }

  const chunks = text.split("\n");

  return (
    <>
      {chunks.map((chunk: string) => {
        return (
          <>
            <span>{chunk}</span>
            <br />
          </>
        );
      })}
    </>
  );
};
